import React from 'react'

const Privacy = () => {
    return (
        <div className="scroll-menu">
            <div className='row container-width margin-center '>
                <div className='tittle-terms mt-6'>POLÍTICA DE PRIVACIDAD CEOTIC</div>

                <div className='paragraph'>La presente Política de Privacidad establece los términos en que SOLUCIONES
                    CEOTIC S.A.S. (en adelante CEOTIC) usa y protege la información que es
                    proporcionada por sus usuarios al momento de utilizar los diferentes canales de
                    comunicación disponibles para tal fin.
                </div>

                <div className='paragraph'>
                    Esta compañía está comprometida con la seguridad de los datos de sus usuarios.
                    Cuando se solicita llenar campos de información personal y corporativa con la
                    cual usted puede ser identificado, CEOTIC se asegura de que dicha información
                    sólo se empleará de acuerdo con los términos de este documento. Esta Política de
                    Privacidad puede cambiar con el tiempo o ser actualizada por lo que se
                    recomienda y revisar continuamente para asegurarse que está de acuerdo con
                    dichos cambios.
                </div>

                <div className='tittle-terms'>Información solicitada</div>

                <div className="paragraph">
                    Los diferentes canales utilizados por CEOTIC podrán recoger información personal
                    por ejemplo: Nombre, información de contacto como su dirección de correo
                    electrónica e información demográfica. Así mismo cuando sea necesario podrá ser
                    requerida información específica para procesar algún pedido o realizar una
                    entrega o facturación.
                </div>

                <div className="paragraph">
                    En cuanto a información de tipo corporativo, CEOTIC en cumplimiento de su
                    actividad económica podría solicitar información de tipo financiera, estratégica o
                    táctica, así como información relacionada con los procesos y procedimientos
                    específicos de la compañía a la que Usted pertenece, en cuyo caso, CEOTIC
                    actuará bajo los términos de confidencialidad y tratamiento de información
                    presentes en este documento.
                </div>

                <div className="tittle-terms">Uso de la información recogida</div>

                <div className="paragraph">
                    La información que CEOTIC solicita, tiene como finalidad proporcionar el mejor
                    servicio posible, particularmente para mantener un registro de usuarios, medir el
                    impacto generado a través de los productos y servicios contratados, y tener
                    oportunidad de mejorarlos.
                </div>

                <div className="paragraph">
                    Es posible que sean enviados correos electrónicos periódicamente con ofertas
                    especiales, nuevos productos y otra información publicitaria que consideremos
                    relevante para usted o que pueda brindarle algún beneficio, estos correos
                    electrónicos serán enviados a la dirección que usted proporcione.
                </div>

                <div className="paragraph">
                    CEOTIC está actualmente comprometida para cumplir con el compromiso de
                    mantener su información segura, utilizando sistemas de información avanzados y
                    actualizados constantemente para evitar que exista algún acceso no autorizado.
                </div>

                <div className="paragraph">
                    CEOTIC trata, con estricta confidencialidad profesional, la información sensible
                    aportada por sus clientes y usuarios, evitando que se divulgue de manera
                    inadecuada o entre personas externas a la compañía.
                </div>

                <div className="tittle-terms">Control de la información personal y corporativa</div>

                <div className="paragraph">
                    CEOTIC, obrando en el marco de la ley, no venderá, no cederá y no distribuirá la
                    información personal o corporativa recopilada a través de sus diferentes canales,
                    sin su previo consentimiento.
                </div>

                <div className="paragraph">
                    CEOTIC se reserva el derecho de cambiar los términos de la presente política de
                    privacidad en cualquier momento.
                </div>

                <div className="paragraph">
                    Los derechos que le asisten a los usuarios clientes, suscriptores y proveedores
                    titulares de los datos personales, son: conocer, actualizar y solicitar la
                    rectificación o supresión de datos; solicitar pruebas relacionadas con el servicio
                    prestado; saber del uso que CEOTIC ha hecho de sus datos personales; revocar en
                    cualquier momento la autorización de inclusión de sus datos personales en las
                    bases de datos de CEOTIC; solicitar sin costo alguno los datos personales
                    previamente autorizados.
                </div>

                <div className="paragraph">
                    Acorde con la normatividad vigente que regula la confidencialidad y el Derecho de
                    Habeas data, los titulares de los datos personales, podrán solicitar la supresión de
                    los mismos mediante comunicado dirigido a SOLUCIONES CEOTIC S.A.S., a la Calle
                    26 A # 9-41. Villa docente, Popayán - Colombia, o al correo
                    ceotic.servicio@gmail.com
                </div>
            </div>
        </div>
        )
}

export default Privacy
